var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWorkspacesHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0067FF",
    height: "100%",
    width: "100%",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 488 488",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M299.3,329.4h-42.1l0,0h-26.5l0,0h-42.1c-9.3,0-17,7.6-17,17v61.8c0,9.3,7.6,17,17,17h110.6c9.3,0,17-7.6,17-17v-61.8 C316.3,337.1,308.6,329.4,299.3,329.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471,329.4h-42.1l0,0h-26.5l0,0h-42.1c-9.3,0-17,7.6-17,17v61.8c0,9.3,7.6,17,17,17H471c9.3,0,17-7.6,17-17v-61.8 C487.9,337.1,480.3,329.4,471,329.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,329.4H85.6l0,0H59.1l0,0H17c-9.3,0-17,7.6-17,17v61.8c0,9.3,7.6,17,17,17h110.6c9.3,0,17-7.6,17-17v-61.8 C144.6,337.1,137,329.4,127.7,329.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6,276.5h145.2v29.6h26.5v-29.6h145.2v29.6H429v-42.9c0-7.3-5.9-13.2-13.2-13.2H257.2v-43.8h74.5 c11.3,0,20.6-9.3,20.6-20.6V83.4c0-11.3-9.3-20.6-20.6-20.6h-67.9l0,0h-39.7l0,0h-67.9c-11.3,0-20.6,9.3-20.6,20.6v102.3 c0,11.3,9.3,20.6,20.6,20.6h74.5v43.8H72.3c-7.3,0-13.2,5.9-13.2,13.2v42.9h26.5C85.6,306.2,85.6,276.5,85.6,276.5z M169.2,110.5 c0-3.3,2.7-5.9,5.9-5.9h137.8c3.3,0,5.9,2.7,5.9,5.9v7.8c0,3.3-2.7,5.9-5.9,5.9H175.1c-3.3,0-5.9-2.7-5.9-5.9L169.2,110.5 L169.2,110.5z M175.1,164.3c-3.3,0-5.9-2.7-5.9-5.9v-7.8c0-3.3,2.7-5.9,5.9-5.9h137.8c3.3,0,5.9,2.7,5.9,5.9v7.8 c0,3.3-2.7,5.9-5.9,5.9H175.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkspacesHierarchy);
export default __webpack_public_path__ + "static/media/icon-workspaces-hierarchy.468e7b0780eb9d313380890d43d3d872.svg";
export { ForwardRef as ReactComponent };